<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHeart, faCopyright } from '@fortawesome/free-solid-svg-icons';

library.add(faHeart, faCopyright);
export default {
  name: 'ComponentsFooter',
  computed: {
    thisYear () {
      return (new Date()).getUTCFullYear();
    },
  },
};
</script>
<template>
  <footer class="d-flex justify-content-between align-items-center">
    <span>
      <!-- Made with <font-awesome-icon icon="heart" class="heart" /> by
      <a href="https://triplebits.com" target="_blank">TripleBits</a> -->
    </span>
    <span>Copyright <font-awesome-icon icon="copyright" class="copyright" /> {{ thisYear }}</span>
    <router-link to="#">Version: 0.2.0</router-link>
  </footer>
</template>
